import { TestResultDropdownOptions, TestAsFoundResultValue } from '../../../TestResultComponent/TestResult.formulas';

export const TestResultSectionDataP615 = (selectedTag, formData) => ({
    rows: [{
        key: 1,
        fields: [{
            key: 'F577SolenoidValvePositionAfterTest',
            label: 'Solenoid Valve Position After Test',
            value: formData.F577SolenoidValvePositionAfterTest,
            isRequired: true,
            isDropDown: true,
            placeholder: 'Select Open or Closed',
            options: [{ name: 'Select Open or Closed', value: '' },
            { name: 'Open', value: 'Open' },
            { name: 'Closed', value: 'Closed' }],
            direction: 'rtl',
            xs: 6,
            width: '49%',
            labelWidth: '51.9%',
            inputTextAlign: 'center',
        },
        {
            key: 'F16Test_Result_Label',
            label: 'Test Result',
            xs: 3,
            labelWidth: '96%',
            padding: '5px 0 0 0',
            fontWeight: '600',
            fontSize: '9pt',
            textAlign: 'end',
            isLabel: 'true'
        },
        {
            key: 'F85TestResult',
            value: TestAsFoundResultValue(formData) ? '' : formData.F85TestResult,
            isRequired: true,
            isDropDown: true,
            placeholder: 'Select Test Result',
            options: TestResultDropdownOptions(formData),
            xs: 3,
            labelWidth: '0',
            width: '100%',
        }]
    }]
});
